<div class="card">
  <div class="card-header pb-1 pt-1">
    <div class="d-flex justify-content-between">
      <div class="align-content-center card-title d-flex align-items-center">
        Radiation Areas
        <waiting-dots
          *ngIf="loading"
          class="panel-loading-indicator"
          matTooltip="Refreshing"
          aria-label="Refreshing Radiation Areas"
        ></waiting-dots>
      </div>
      <div class="d-flex justify-content-end header-buttons">
        <button
          mat-icon-button
          class="ml-1"
          color="accent"
          *ngIf="this.hasPrivilege(privilegeEnum.RadAreaCreate)"
          (click)="addRA()"
        >
          <mat-icon>add_box</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body px-2 pb-1 pt-2 pb-2">
    <div class="d-flex flex-wrap rad-area-items">
      <div
        class="card flex-fill rad-tile ra-item"
        *ngFor="let radArea of radAreas; let i = index"
      >
        <div class="card-header d-flex justify-content-between pl-2 pr-1 py-1">
          <div class="align-content-center">
            <span>{{ radArea.name }}</span>
          </div>
          <div class="justify-content-end">
            <button
              mat-icon-button
              *ngIf="
                this.hasPrivilege(privilegeEnum.RadAreaModify) ||
                this.hasPrivilege(privilegeEnum.RadAreaDelete)
              "
              class="focus-outline-none"
              color="primary"
              [matMenuTriggerFor]="options"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu
              #options="matMenu"
              id="{{ 'contentOptions-' + i }}"
              class="d-flex flex-column align-items-start"
            >
              <hr class="my-0" />
              <button
                mat-menu-item
                *ngIf="this.hasPrivilege(privilegeEnum.RadAreaModify)"
                (click)="editRA(radArea)"
              >
                <mat-icon color="accent">edit</mat-icon
                ><span class="Option">Edit</span>
              </button>
              <button
                mat-menu-item
                *ngIf="this.hasPrivilege(privilegeEnum.RadAreaDelete)"
                (click)="deleteRA(radArea)"
              >
                <mat-icon color="warn">delete</mat-icon
                ><span class="Option">Delete</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="card-body p-1">
          <div class="d-flex flex-wrap justify-content-center rad-area-images">
            <div class="p-1" *ngFor="let file of radArea.files">
              <a [href]="file.url" target="_blank">
                <img class="rad-area-img" [src]="file.url" alt="Rad Area" />
              </a>
            </div>
          </div>
          <div class="row pl-2">
            <div class="col-12 small rad-area-description">
              <span>{{ radArea.description }}</span>
            </div>
          </div>
        </div>
        <div class="card-footer ra-card-footer px-2 py-2">
          <div class="last-changed gray">
            <span>Last Changed</span>
            <span class="date">
              {{ getLastChangedOn(radArea) | date: "yyyy-MM-dd h:mm a" }}
            </span>
            <span
              class="last-changed-check"
              [matTooltip]="getLastChangedByName(radArea)"
            >
              {{ getLastChangedByInitials(radArea) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
